import { useTranslation } from "react-i18next";

import { IPartsRemovedKpi } from "../../models/ProductionDashboard";

interface PartsRemovedKpiCardProps {
  partsRemoved: IPartsRemovedKpi;
}

export default function PartsRemovedKpiCard({ partsRemoved }: PartsRemovedKpiCardProps) {
  const { t } = useTranslation("production");

  return (
    <div className="flex-1 bg-white border border-gray-200 rounded-md p-4 min-w-[180px]">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
        {t("No. Parts Removed")}
      </div>
      <div className="mt-2 text-2xl font-semibold text-gray-900">{partsRemoved.total}</div>
      {partsRemoved.breakdown.length > 0 && (
        <div className="mt-2 text-xs text-gray-600 flex flex-wrap gap-x-3 gap-y-1">
          {partsRemoved.breakdown.map((b) => (
            <span key={b.name}>
              <span className="font-semibold text-gray-900">{b.count}</span>{" "}
              <span className="text-gray-500">{b.name}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
